<template>
  <div>
    <el-card shadow="never">
      <div slot="header" class="clearfix">
        <span>授权管理</span>
      </div>

      <el-form :inline="true" :model="formSearch" class="demo-form-inline" size="mini">
        <el-form-item label="应用名称">
          <el-input v-model="formSearch.applyname" placeholder="应用名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="query">查询</el-button>
        </el-form-item>

      </el-form>

      <el-table :data="list" size="mini">
        <el-table-column prop="applyno" label="应用编号"></el-table-column>
        <el-table-column prop="applyname" label="应用名称"></el-table-column>
        <el-table-column prop="merchno" label="商户编号"></el-table-column>
        <el-table-column prop="merchname" label="商户名称"></el-table-column>
        <el-table-column prop="sqcount" label="申请轮次">
          <template slot-scope="scope">
            第{{scope.row.sqcount}}次
          </template>
        </el-table-column>
        <el-table-column prop="createtime" label="申请时间"></el-table-column>
        <el-table-column prop="state" label="申请单状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.state == '2'" type="danger" disable-transitions>已驳回</el-tag>
            <el-tag v-if="scope.row.state == '1'" type="success" disable-transitions>已授权</el-tag>
            <el-tag v-if="scope.row.state == '0'" type="primary" disable-transitions>未处理</el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">查看申请</el-button>
          </template>
        </el-table-column>
      </el-table>

    </el-card>

    <el-drawer :visible.sync="drawerClient" :with-header="false" size="40%">
      <el-card shadow="never">
        <div slot="header" class="clearfix">
          <span>查看</span>
        </div>
        <div class="drawer_body">
          <el-tabs v-model="activeName">
            <el-tab-pane label="意见查看" name="first">
              <el-form :model="client" :rules="clientRules" ref="clientForm" label-width="110px" size="mini">
                <el-divider content-position="left" v-if="contents.length > 0">意见查看</el-divider>
                <el-form-item :label="item.contype == 'pt'? '平台：' : '商户：'" v-for="(item,index) in contents"  :key="index">
                  <div class="row">
                    <div>{{item.content}} </div>
                    <!-- <div>{{item.createtime}}</div> -->
                  </div>
                  <!-- <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="item.content"></el-input> -->
                </el-form-item>
                <el-divider content-position="left">意见反馈</el-divider>
                <el-form-item label="意见内容" prop="content">
                  <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="client.content"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="onSubmit">确认</el-button>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="申请配置" name="second">
              <el-form :model="client"label-width="110px" size="mini">
                <el-form-item label="包名">
                  <el-input v-model="client.packagename"></el-input>
                </el-form-item>
                <el-form-item label="short_key">
                  <el-input type="textarea" :rows="3" v-model="client.shortkey"></el-input>
                  <span style="color:red">*补充说明：“如果前缀有"-"符号，请勿舍去”</span>
                </el-form-item>
                <el-form-item label="long_key">
                  <el-input type="textarea" :rows="12" v-model="client.longkey"></el-input>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>

        </div>
      </el-card>
    </el-drawer>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data () {
    return {
      activeName: 'first',
      drawerClient:false,
      list:[],
      contents:[],
      formSearch: {
        applyname: ''
      },
      client:{},
      clientRules:{
        content: [
          { required: true, message: '必填', trigger: 'blur' }
        ]
      },
    }
  },
  created(){
    this.query();
  },
  methods: {
    query(){
      let _this = this;
      let info = this.$store.state.userInfo;
      this.formSearch.merchno = info.userbh;
      this.$ajax({
        url:"coupon-merch/merch/list/client",
        async:false,
        methods:'POST',
        data:_this.formSearch,
        token:window.sessionStorage.getItem('token'),
        success:function(response){
          if (response.code== 0) {
            _this.list = response.data;
          }else{
            _this.$message.error(response.message);
          }
        },
        error:function(){
          _this.$message.error("查询失败");
        }
      })
    },
    handleClick(row){
      let _this = this;
      this.$ajax({
        url:"coupon-merch/merch/list/client/content",
        async:false,
        methods:'POST',
        data: {'clientid':row.id},
        token:window.sessionStorage.getItem('token'),
        success:function(response){
          if (response.code == 0) {
            _this.client.clientid = row.id;
            _this.client.applyno = row.applyno;
            _this.client.merchno = row.merchno;
            _this.client.state = row.state;
            _this.client.packagename = row.packagename;
            _this.client.shortkey = row.shortkey;
            _this.client.longkey = row.longkey;
            _this.drawerClient = true
            _this.contents = response.data
          }else{
            _this.$message.error(response.message);
          }
        },
        error:function(){
          _this.$message.error("请求失败");
        }
      })
    },
    onSubmit(){
      let _this = this;
      this.$refs.clientForm.validate((valid) => {
        if (valid) {
          this.$ajax({
            url:"coupon-merch/merch/add/client/content",
            async:false,
            methods:'POST',
            data:_this.client,
            token:window.sessionStorage.getItem('token'),
            success:function(response){
              if (response.code==0) {
                _this.drawerClient = false;
                _this.client = {};
              }else{
                _this.$message.error(response.message);
              }
            },
            error:function(){
              _this.$message.error("请求失败");
            }
          })
        } else {
          return false;
        }
      });
    },
  }
}
</script>
<style>
  .row{
    background-color: #99ffcc;
    padding: 3px;
    font-size: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/merch/client.vue